import { Component, Output, Input, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { Dictionary } from '../../../helper/util';
import { Log } from 'src/app/core/log';

/**
 * Sample usage:
  <bitwise-input [mainLabel]="'New Bitwise Test'" [bitwiseLabels]="bitwiseLabels" (selectionChanged)="testBitwiseChanged($event)"></bitwise-input>
  
  bitwiseValue: number = 0;
  bitwiseLabels: string [] = ['Option1', 'Option2', 'Option3'] ;
  testBitwiseChanged(bitwiseVal: number) {
    Log.debug('bitwise component test changed value: ' + bitwiseVal)
  }
 */
@Component({
  selector: 'app-radio-input',
  templateUrl: 'radio-input.html',
  styleUrls: ['radio-input.scss']
})
export class RadioInputComponent implements OnChanges {

  @Input() mainLabel?: string;
  @Input() description?: string;

  // THIS IS TO HANDLE TWO WAY BINDING
  @Input() get radioValue(): any {
    return this.modelValue;
  }
  set radioValue(val: any) {
    this.modelValue = val;
    this.radioValueChange.emit(this.modelValue);
  }
  @Output() radioValueChange = new EventEmitter();
  private modelValue: any;
  // END OF TWO WAY BINDING

  // descriptors of each option
  @Input() radioLabels: string[] = [];
  @Input() radioDescriptions: string[] = [];

  // use values array that is passed in
  @Input() radioValuesString: string[] = [];
  @Input() radioValuesNumber: number[] = [];
  @Input() radioValuesBoolean: number[] = [];

  selectedIdx?: number;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initRadio();
  }

  // find index where value matches, make that selectedIdx
  private initRadio() {
    if (this.radioValuesBoolean != null) {
      Log.debug('radio values boolean, current value ' + this.radioValue, this.radioValuesBoolean)
      this.selectedIdx = this.radioValuesBoolean.indexOf(this.radioValue)
    } else if (this.radioValuesString != null) {
      Log.debug('radio values string, current value ' + this.radioValue, this.radioValuesString)
      this.selectedIdx = this.radioValuesString.indexOf(this.radioValue)
    } else if (this.radioValuesNumber != null) {
      Log.debug('radio values number, current value ' + this.radioValue, this.radioValuesNumber)
      this.selectedIdx = this.radioValuesNumber.indexOf(this.radioValue)
    }
  }

  // this function should be run upon change of any selection, so the 
  // actual value, bitwiseValue, is updated to reflected the change
  selectionChange(idx: number) {
    Log.debug('selection clicked: ' + idx)
    this.selectedIdx = idx;
    if (this.radioValuesBoolean != null) {
      this.radioValue = this.radioValuesBoolean[idx];
    } else if (this.radioValuesString != null) {
      this.radioValue = this.radioValuesString[idx];
    } else if (this.radioValuesNumber != null) {
      this.radioValue = this.radioValuesNumber[idx];
    }
    Log.debug('radioValue set to  ' + this.radioValue);
  }
}
